import { sub } from "date-fns";
import { useEffect, useState } from "react";
import { DateValue, useId } from "react-aria";
import { Control, Controller } from "react-hook-form";
import { Checkbox } from "semantic-ui-react";
import { useTimezone } from "../../../../../../hooks/useTimezone";
import { errorMessageSelector } from "../../../../../data-filters/components/Utils";
import { DateTimePicker } from "../../../../../../components/global_components/form_components/accessible/DateTimePicker";

export function ControlledDatetimeToggle({
  control,
  name,
  label,
  isDateUnavailable,
  rules,
  errors,
}: {
  control: Control;
  name: string;
  label: string;
  isDateUnavailable?: (date: DateValue) => boolean;
  rules?: any;
  errors?: any;
}) {
  const {
    defaultTimezoneInfo: { timezone },
  } = useTimezone();

  const finalIsDateUnavailable = isDateUnavailable
    ? isDateUnavailable
    : (date: DateValue) => date.toDate(timezone) < sub(new Date(), { days: 1 });

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ value, onChange }) => {
        const [showInput, setShowInput] = useState(!!value);

        const id = useId();

        const error = errorMessageSelector(errors)(name);

        useEffect(() => {
          if (value) {
            setShowInput(true);
          }
        }, [value, setShowInput]);

        return (
          <div className='tw-space-y-2'>
            <Checkbox
              id={id}
              label={label}
              checked={showInput}
              onChange={() => {
                if (showInput) {
                  onChange(null);
                }
                setShowInput((prev) => !prev);
              }}
              toggle
            />
            {showInput && (
              <DateTimePicker
                // granularity='minute'
                value={value}
                onChange={(date) => {
                  setShowInput(true);
                  onChange(date);
                }}
                isDateUnavailable={finalIsDateUnavailable}
                error={error}
                useClientTimezone
                showErrors
                // ariaLabeledBy={id}
              />
            )}
          </div>
        );
      }}
    />
  );
}
